module.exports = __webpack_public_path__ + "static/media/6kdj1x.21dc755e.jpg";